<div class="h-full hidden sm:flex items-center gap-3">
    <app-account-menu type="salesperson" />
</div>
